.page {
  display: grid;
  gap: var(--dimension-space-6);
  max-width: 402px;
  margin: 0 auto;
  padding: var(--dimension-space-4) var(--gutter) var(--dimension-space-12);
}
.block {
  display: grid;
  gap: var(--dimension-space-2);
}
.inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--dimension-space-3);
}
.buttons {
  display: grid;
  justify-items: start;
  gap: var(--dimension-space-3);
}
